// extracted by mini-css-extract-plugin
export default {"iconButton":"iconButton--ZnINj"};